import React from "react";
import "../../../i18n";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BusinessManagement = () => {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">{t("admin_business.title")}</h4>
            <div className="d-flex flex-column gap-2 mt-4 align-items-start">
              <Link to="/business-management/list" className="btn btn-primary">
                {t("admin_business.buttons.list")}
              </Link>
              <Link
                to="/business-management/active"
                className="btn btn-outline-primary"
                style={{ backgroundColor: "#7EC8FF", borderColor: "#7EC8FF", color: "#ffffff" }}
              >
                {t("admin_business.buttons.active")}
              </Link>
              <Link
                to="/business-management/create"
                className="btn btn-success"
                style={{ backgroundColor: "#D97ADF", borderColor: "#D97ADF", color: "#ffffff" }}
              >
                {t("admin_business.buttons.create")}
              </Link>
              <Link to="/business-management/edit" className="btn btn-success" style={{ backgroundColor: "#A8E06E", borderColor: "#A8E06E", color: "#ffffff" }}>
                {t("admin_business.buttons.edit")}
              </Link>
              <Link
                to="/business-management/assign-users"
                className="btn btn-warning"
                style={{ backgroundColor: "#F4B740", borderColor: "#F4B740", color: "#ffffff" }}
              >
                {t("admin_business.buttons.assign_users")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessManagement;
